// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"7":"1ffb3fbc","224":"e9107755","640":"4da7450d","655":"661f4181","874":"c78999e9","927":"99066b11"}[chunkId] + ".css";
};